module.exports = __webpack_public_path__ + "static/media/spicegrill.5c83f22f.jpg";